import React from 'react';
import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';
import Hidden from '@material-ui/core/Hidden';
import { useRootStore } from '../../../../mobx/bridge';
import styles from './InnerToolbar.module.css';
import * as utils from '../../../../helpers/utils';
import RightSideBar from '../RightSideBar/RightSideBar';
import { getChannelIcon, getChannelTypeLabel } from '../../../../helpers/channelHelpers';
import { getCustomerFromSmsChannel } from '../../../../helpers/contactHelpers';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const InnerToolbar = observer(function InnerToolbar() {
  const { commonStore, settingsStore } = useRootStore();
  const { t } = useTranslation();

  const settings = settingsStore.getLoggedUserSettings;

  const showMoreInfo = () => {
    const component = { name: utils.rightSideComponents.ChannelInfo, component: <RightSideBar /> };

    commonStore.setToggleRightSideComponent(component, utils.rightSideComponents.ChannelInfo);
  };

  let selectedChannelName = null;
  let phoneNumber = null;
  let channelIcon = null;
  let channelLabel = null;
  const labelStyle = [styles.channelLabel];
  const infoBtnStyle = [styles.channelDetails];

  if (settings) {
    if (!settings.SelectedChannel || Object.keys(settings.SelectedChannel).length === 0) {
      selectedChannelName = t('Common.NoContactSelected');
    } else if (settings.SelectedChannel) {
      const { Contacts, ChannelType } = settings.SelectedChannel;

      let contact;
      if (ChannelType.TypeId === utils.ChannelTypeEnum.SMS.TypeId) {
        contact = getCustomerFromSmsChannel(settings.SelectedChannel);
      } else if (ChannelType.TypeId === utils.ChannelTypeEnum.WebChat.TypeId) {
        contact = Contacts.find(
          (f) =>
            f.ContactType &&
            f.ContactType.TypeId === utils.ContactTypeEnum.WebChatContact.TypeId &&
            !f.IsDeleted
        );
      }

      if (contact) {
        if (contact.DisplayName || contact.FirstName || contact.LastName || contact.CompanyName) {
          selectedChannelName = contact.getFullName;

          if (settings.SelectedChannel.CustomerPhoneNumber) {
            phoneNumber = `${
              settings.SelectedChannel.CustomerPhoneNumber.Description
                ? settings.SelectedChannel.CustomerPhoneNumber.Description
                : ''
            } ${settings.SelectedChannel.CustomerPhoneNumber.Number}`.trim();
          }
        } else if (contact.CpUsername) {
          selectedChannelName = contact.CpUsername;
        } else if (settings.SelectedChannel.CustomerPhoneNumber) {
          selectedChannelName = t('Common.UnknownContact');
          phoneNumber = `${settings.SelectedChannel.CustomerPhoneNumber.Description || ''} ${
            settings.SelectedChannel.CustomerPhoneNumber.Number
          }`.trim();
        }

        // const matchedContacts = commonStore.customersData.some((c) =>
        //   c.phones?.some(
        //     (p) => `+1${p.number}` === settings.SelectedChannel?.CustomerPhoneNumber?.TwilioFormat
        //   )
        // );
        //
        // if (matchedContacts?.length > 1) {
        //   selectedChannelName += matchedContacts
        //     .filter(
        //       (f) =>
        //         selectedChannelName.toLowerCase() !== `${f.firstName} ${f.lastName}`.toLowerCase()
        //     )
        //     .map((m) => `${m.firstName} ${m.lastName}`.trim())
        //     .join(', ');
        // }
      } else {
        selectedChannelName = t('InnerToolbar.NoContact');
      }
    }

    channelIcon = getChannelIcon(settings.SelectedChannel);
    channelLabel = getChannelTypeLabel(settings.SelectedChannel);

    if (
      settings.SelectedChannel?.ChannelType &&
      settings.SelectedChannel.ChannelType.TypeId === utils.ChannelTypeEnum.WebChat.TypeId
    ) {
      labelStyle.push(styles.blueLabel);
      infoBtnStyle.push(styles.blueBtns);
    }

    if (
      commonStore.rightSideComponentOpen &&
      commonStore.rightSideComponentOpen.name === utils.rightSideComponents.ChannelInfo
    ) {
      infoBtnStyle.push(styles.selected);
    }
  }

  return (
    <Grid
      component="div"
      container
      justify="flex-start"
      alignItems="center"
      className={styles.innerToolbarContainer}
    >
      <Grid component="div" item xs={12}>
        {settings?.SelectedChannel ? (
          <Hidden xsDown>
            <img src={channelIcon} alt="Channel logo" className={styles.channelIcon} />
          </Hidden>
        ) : null}

        <span className={styles.innerToolbarName} data-testid="innerToolbarName">
          {selectedChannelName}
        </span>

        {settings?.SelectedChannel ? (
          <Hidden xsDown>
            <span className={labelStyle.join(' ')}>{channelLabel}</span>
          </Hidden>
        ) : null}

        {phoneNumber ? (
          <span className={styles.innerPhoneNumber} data-testid="innerToolbarPhoneNumber">
            {phoneNumber}
          </span>
        ) : null}

        {settings && settings.SelectedChannel ? (
          <div className={styles.buttonsHolder}>
            <div className={styles.buttonWrapper}>
              <Tooltip
                arrow
                enterDelay={1000}
                title={t('InnerToolbar.ChannelDetails')}
                placement="left"
              >
                <button
                  type="button"
                  onClick={showMoreInfo}
                  data-testid="channelDetailsBtn"
                  className={infoBtnStyle.join(' ')}
                >
                  <span className={styles.innerCircle}>i</span>
                </button>
              </Tooltip>
            </div>
          </div>
        ) : null}
      </Grid>
    </Grid>
  );
});
InnerToolbar.whyDidYouRender = true;
InnerToolbar.displayName = 'InnerToolbar';

export default InnerToolbar;
